import { ViewProps } from './discussion.constants';
import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';
import { useStudentGetAnswers } from 'approot/activity-builder/student/answer/student-answer.hooks';
import SubActivityView from '../sub-activity/sub-activity-view';
import DiscussionViewQuestion from './discussion-view-question';
import { DiscussionViewWrapper } from './discussion-view.style';
import ComponentLoading from '../shared/component-loading';

type Props = ViewProps & {
  isLoggedIn: boolean;
};

const DiscussionStudent = (props: Props) => {
  const { id, type, properties, subActivityProperties, isLoggedIn } = props;
  const { style } = properties;

  const { activeComponent, setActiveComponent } =
    useActivityBuilderPresentContext();
  const isActive = activeComponent?.id === id;

  const { hasFetchedAnswers, error } = useStudentGetAnswers({
    componentId: id,
    skip: !isLoggedIn,
  });

  return (
    <SubActivityView subActivityDetails={subActivityProperties}>
      <DiscussionViewWrapper>
        <DiscussionViewQuestion
          id={id}
          type={type}
          discussion={properties.discussion}
          style={style}
          isActive={isActive}
          componentLoading={
            isLoggedIn && (
              <ComponentLoading hasData={hasFetchedAnswers} error={error} />
            )
          }
          onInstructionClick={() =>
            setActiveComponent(isActive ? undefined : { id })
          }
        />
      </DiscussionViewWrapper>
    </SubActivityView>
  );
};

export default DiscussionStudent;
